<template>
    <div class="index-box">

        <div class="h5-box">
            <!-- <div class="head-tabs">
                <div class="logo-img">
                    <div class="img-box"></div>
                    <div class="text">KPHONE8</div>

                </div>
                <div class="tabs-btn-list">
                    <div class="btn">首页</div>
                    <div class="btn">下载</div>
                    <div class="btn">教程</div>
                    <div class="btn">产品</div>
                    <div class="btn">留言</div>
                    <div class="btn">关于我们</div>
                </div>
            </div> -->

        </div>

        <div class="banner-box confirm-box">
            <el-carousel :interval="5000" arrow="always">
                <el-carousel-item>
                    <div class="img-banner">
                        <!-- <img src="https://15611039.s21i.faiusr.com/2/ABUIABACGAAgmaDH7AUorqddMIAPOKYE.jpg.webp" alt=""> -->
                        <img id="banner1" src="@/assets/image/index/banner01.jpg" alt="">
                        <img id="banner2" src="@/assets/image/index/banner02.jpg" alt="">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="info-box confirm-box">
            <div class="info-box-img">
                <img src="https://15611039.s21i.faiusr.com/2/ABUIABACGAAgsazA7QUoivXdywMw7gU4-QE!1500x1500.jpg.webp"
                    alt="">
            </div>
            <div class="info-item-box confirm">
                <div class="info-curr-box ">
                    <div class="trem-title">超低的人工成本</div>
                    <div class="icon-box">
                        <div class="icon">
                            <!-- <i class="el-icon-map-location"></i> -->
                            <img src="@/assets/image/index/info1.png" alt="">
                        </div>
                    </div>
                    <div class="trem-tip">每人每天最低 <span>0.5元</span> 钱
                        低于销售员工资的 <span>2‰</span></div>
                </div>
                <div class="info-curr-box ">
                    <div class="trem-title">提高3倍拨号效率
                    </div>
                    <div class="icon-box">
                        <div class="icon">
                            <!-- <i class="el-icon-map-location"></i> -->
                            <img src="@/assets/image/index/info2.png" alt="">
                        </div>

                    </div>
                    <div class="trem-tip">通过 批量 <span>自动拨号+屏幕取号</span> 钱
                        ，比人工拨号打电话快<span>300%</span></div>

                </div>
                <div class="info-curr-box ">
                    <div class="trem-title">20万+用户选择
                    </div>
                    <div class="icon-box">
                        <div class="icon">
                            <!-- <i class="el-icon-map-location"></i> -->
                            <img src="@/assets/image/index/info3.png" alt="">
                        </div>

                    </div>
                    <div class="trem-tip">系统<span> 简单易用</span> 钱
                        ，广受企业客户的好评，目前已有<span>20W+</span> 的注册用户在使用</div>

                </div>
            </div>


        </div>
        <div class="pc-box">
            <div class="display-box confirm-box">
                <div class="display-item-box confirm">
                    <div class="left-box">
                        <div class="img-show"><img src="@/assets/image/index/gif1.gif" alt=""></div>
                    </div>
                    <div class="right-box">
                        <div class="title">局内网解锁
                        </div>
                        <div class="info">为保证数据安全性，系统软件可根据实际情况进行局
                            内网设置，提供了一个高效、安全、可控的内部环境。
                        </div>
                        <div class="btn" @click="jumpDown">
                            <img src="@/assets/image/index/free.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="display-box confirm-box">
                <div class="display-item-box confirm">
                    <div class="right-box">
                        <div class="title">挂机短信
                        </div>
                        <div class="info">打陌拜电话时，在电话挂断后，可以自动发送一条挂断短信给客户，做一个简单的自我介绍或者邀请客户添加微信，为后期成交做铺垫。

                        </div>
                        <div class="btn" @click="jumpDown">
                            <img src="@/assets/image/index/free.png" alt="">
                        </div>
                    </div>
                    <div class="left-box">
                        <div class="img-show">
                            <img src="@/assets/image/index/gif2.gif" alt="">
                        </div>
                    </div>

                </div>
            </div>
            <div class="display-box confirm-box">
                <div class="display-item-box confirm">
                    <div class="left-box">
                        <div class="img-show">
                            <img src="@/assets/image/index/display01.png" alt="">
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="title">坐席统计报表
                        </div>
                        <div class="info">管理员可以在后台查看每个座席的通话统计报表，如总外呼次数，总接听次数，接听率，通话时长等等。
                        </div>
                        <div class="btn" @click="jumpDown">
                            <img src="@/assets/image/index/free.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="display-box confirm-box">
                <div class="display-item-box confirm">
                    <div class="right-box">
                        <div class="title">座席通话记录

                        </div>
                        <div class="info">管理员在后台查看每个座席的通话统计报表，如总外呼次数、总接听次数、接通率，通话时长等。

                        </div>
                        <div class="btn" @click="jumpDown">
                            <img src="@/assets/image/index/free.png" alt="">
                        </div>
                    </div>
                    <div class="left-box">
                        <div class="img-show">
                            <img src="@/assets/image/index/display02.png" alt="">
                        </div>
                    </div>

                </div>
            </div>
            <!-- <div class="display-box confirm-box">
                <div class="display-item-box confirm">
                    <div class="left-box">
                        <div class="img-show">
                            <img src="@/assets/image/index/display5.png" alt="">

                        </div>
                    </div>
                    <div class="right-box">
                        <div class="title">CRM客户管理
                        </div>
                        <div class="info">管理员可以导入批量客户资料，并分配给员工，避免了飞单、撞单的情况。
                        </div>
                        <div class="btn">
                            <img src="@/assets/image/index/free.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="display-box confirm-box">
                <div class="display-item-box confirm">
                    <div class="right-box">
                        <div class="title">座席通话记录
                        </div>
                        <div class="info">登录通话录音管理后台可以查看所有员工的通话记录，通话时长，通话录音，客户标记等等，并可根据实际需要进行筛选过滤查询。
                        </div>
                        <div class="btn">
                            <img src="@/assets/image/index/free.png" alt="">
                        </div>
                    </div>
                    <div class="left-box">
                        <div class="img-show">
                            <img src="@/assets/image/index/display6.png" alt="">
                        </div>
                    </div>

                </div>
            </div>
            <div class="display-box confirm-box">
                <div class="display-item-box confirm">
                    <div class="left-box">
                        <div class="img-show">
                            <img src="@/assets/image/index/display7.png" alt="">
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="title">CRM弹屏
                        </div>
                        <div class="info">坐席在YOBONKE电话管理系统电脑点击拨号或者来电时，会弹出客户详细信息，历史沟通记录。还可以录入当
                            前沟通摘要信息内容。
                        </div>
                        <div class="btn">
                            <img src="@/assets/image/index/free.png" alt="">
                        </div>
                    </div>
                </div>
            </div> -->

        </div>

        <div class="h5-box">

            <!--  <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display1.png" alt="">
                </div>
                <div class="title">鼠标屏幕取号</div>
                <div class="info">任意号码点击拨号，网页号码、QQ聊天工具、excel电子表格点击拨号，不再需要手按数字拨打电话。</div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display2.png" alt="">
                </div>
                <div class="title">批量自动拨号
                </div>
                <div class="info">把表格中的客户资料批量导入到软件中，生成自动外呼任务，自动挨个挨个拨打，一个拨打结束自动拨打下一个，过程中可以备注客户信息。
                </div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display3.png" alt="">
                </div>
                <div class="title">挂机短信
                </div>
                <div class="info">打陌拜电话时，在电话挂断后，可以自动发送一条挂断短信给客户，做一个简单的自我介绍或者邀请客户添加微信，为后期成交做铺垫。
                </div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display4.png" alt="">
                </div>
                <div class="title">坐席统计报表
                </div>
                <div class="info">管理员可以在后台查看每个座席的通话统计报表，如总外呼次数，总接听次数，接听率，通话时长等等。
                </div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display5.png" alt="">
                </div>
                <div class="title">CRM客户管理
                </div>
                <div class="info">管理员可以导入批量客户资料，并分配给员工，避免了飞单、撞单的情况。
                </div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display6.png" alt="">
                </div>
                <div class="title">座席通话记录
                </div>
                <div class="info">管理员在后台查看每个座席的通话统计报表，如总外呼次数、总接听次数、接通率，通话时长等。
                </div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display7.png" alt="">
                </div>
                <div class="title">CRM弹屏

                </div>
                <div class="info">座席在YOBONKE电话管理系统批量拨号时，会弹出客户CRM弹屏，显示客户的详细信息。

                </div>
            </div> -->

            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/gif1.gif" alt="">
                </div>
                <div class="title">局内网解锁
                </div>
                <div class="info">为保证数据安全性，系统软件可根据实际情况进行局内网设置，提供了一个高效、安全、可控的内部环境
                </div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/gif2.gif" alt="">
                </div>
                <div class="title">挂机短信
                </div>
                <div class="info">打陌拜电话时，在电话挂断后，可以自动发送一条挂断短信给客户，做一个简单的自我介绍或者邀请客户添加微信，为后期成交做铺垫。
                </div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display01.png" alt="">
                </div>
                <div class="title">坐席统计报表
                </div>
                <div class="info">管理员可以在后台查看每个座席的通话统计报表，如总外呼次数，总接听次数，接听率，通话时长等等。
                </div>
            </div>
            <div class="display-item-box">
                <div class="img-show">
                    <img src="@/assets/image/index/display02.png" alt="">
                </div>
                <div class="title">座席通话记录
                </div>
                <div class="info">管理员在后台查看每个座席的通话统计报表，如总外呼次数、总接听次数、接通率，通话时长等。
                </div>
            </div>

            <!-- <div class="about-box">
                <div class="term">云邦客 YOBONKE</div>
                <div class="text"> 不在乎那些B2C、C2C还是O2C，始终坚持免费试用会员付费。
                </div>
                <div class="text">
                    拒绝一切资本介入，因为资本介入后会让我们的产品价值变质。
                </div>
                <div class="text">
                    没有销售团队，更没有广告宣传，也没有营销渠道，坚持低成本运作，0销售成本用心做好自己的产品，利润是顺基自然的事情，始终坚持口碑营销策略，大规模的营销推广销售渠道仅仅是昙花一现。
                </div>
            </div> -->



            <div class="item-card">
                <div class="title">YOBONKE手机App
                </div>
                <!-- <div class="tip">支持安卓系统6.1或以上
                            </div> -->
                <div class="img-box" style="width: 128px;">
                    <img src="@/assets/image/down/phone.png" alt="">
                </div>
                <div class="btn-download" @click="downHandle('apk')">Android下载(64位)
                </div>
                <div class="btn-download" @click="downHandle('apk32')">Android下载(32位)
                </div>
                <div class="tip">安卓市场或应用市场

                    搜索 YOBONKE 免费下载

                </div>
            </div>
            <div class="phone-brand">
                <div class="term">YOBONKE软件合作下载渠道
                </div>
                <div class="brand-box">
                    <div class="item-box">
                        <div class="brand-img">
                            <img src="@/assets/image/down/huawei.png" alt="">
                        </div>
                        <div class="brand-text">华为应用市场
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/logo2.png" alt=""></div>
                        <div class="brand-text">腾讯应用宝
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/logo3.png" alt=""></div>
                        <div class="brand-text">360手机助手
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/logo5.png" alt=""></div>
                        <div class="brand-text">豌豆荚
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/logo6.png" alt=""></div>
                        <div class="brand-text">百度应用市场
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/logo7.png" alt=""></div>
                        <div class="brand-text">小米应用市场
                        </div>
                    </div>

                </div>
            </div>
            <div class="phone-brand">
                <div class="term">YOBONKE软件支持手机品牌
                </div>
                <div class="brand-box">
                    <div class="item-box">
                        <div class="brand-img">
                            <img src="@/assets/image/down/logo7.png" alt="">
                        </div>
                        <div class="brand-text">小米</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/logo1.png" alt=""></div>
                        <div class="brand-text">华为</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/nubia.png" alt=""></div>
                        <div class="brand-text">努比亚</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/yijia.png" alt=""></div>
                        <div class="brand-text">一加</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/oppo.png" alt=""></div>
                        <div class="brand-text">OPPO</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"> <img src="@/assets/image/down/pingguo.png" alt=""></div>
                        <div class="brand-text">苹果</div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    methods: {
        downHandle(way) {
            let url = ''
            if (way == 'apk') {
                url = 'https://www.hbsyyrj.cn/YOBONEK_64x.apk' // 64位
            }
            else if (way == 'apk32') {
                url = 'https://www.hbsyyrj.cn/YOBONEK_32x.apk' // 64位
            } else if (way == 'zip') {
                url = 'https://www.hbsyyrj.cn/YOBONEK.zip'
            }
            else if (way == 'zipmini') {
                url = 'https://www.hbsyyrj.cn/ybk_min.zip'
            }
            else if (way == 'win') {
                return window.open('http://bcrms.hbsyyrj.cn/')
            }
            window.location.href = url
        },

        jumpDown() {
            this.$parent.bottomClick('1')

        }
    }
}
</script>

<style lang="less" scoped>
.index-box {
    .confirm-box>.confirm {
        width: 1200px;
        // height: 100%;
        margin: 0 auto;
        // background: red;
    }

    .banner-box {
        height: 550px;
        // padding: 10px;

        /deep/.el-carousel {
            height: 100%;

            .el-carousel__container {
                height: 100%;
            }
        }

        // background-color: orange;
        .img-banner {
            // background: orange;
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
            }
        }

        /deep/ .el-carousel__item {
            background-color: #1e679a;
            height: 100%;

            .el-carousel__arrow {}
        }

        /deep/ .el-carousel__arrow {
            // background-color: red;
            display: none;
        }

        /deep/ .el-carousel__button {
            width: 15px;
            height: 15px;
            border-radius: 50%;
        }
    }

    .info-box {
        height: 350px;

        .info-box-img {
            display: none;
        }

        .info-item-box {
            display: flex;
            justify-content: space-around;

            .info-curr-box {
                padding-top: 20px;
                width: 200px;

                .trem-title {
                    color: #1565C3;
                    font-weight: bold;
                    font-size: 20px;
                    text-align: center;
                }

                .icon-box {
                    text-align: center;

                    .icon {
                        font-size: 100px;
                        width: 192px;
                        height: 192px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .number {
                        font-size: 48px;
                        font-weight: bold;
                        color: #000;

                        span {
                            color: #333333;
                            font-size: 36px;
                        }
                    }
                }

                .trem-tip {
                    font-size: 16px;
                    color: #747577;

                    span {
                        font-weight: bold;
                        font-size: 20px;
                        color: #101010;
                    }
                }
            }
        }
    }

    .pc-box {
        display: block;
    }

    .h5-box {
        display: none;



        .about-box {
            padding: 20px;
            background-color: #f0f0f0;

            .term {
                font-size: 26px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 20px;
            }

            .text {
                text-indent: 2em;
                line-height: 30px;
            }
        }


        .item-card {
            width: 100%;
            height: 450px;
            background-color: #fff;
            text-align: center;

            .title {
                color: #101010;
                font-size: 20px;
                padding-top: 22px;
            }

            .tip {
                color: #747577;
                font-size: 16px;
                padding: 0 60px;
            }

            .btn-download {
                width: 200px;
                height: 45px;
                line-height: 45px;
                text-align: center;
                border-radius: 4px;
                background-color: rgba(1, 176, 187, 1);
                color: #FFF;
                cursor: pointer;
                margin: 0px auto 7px;

            }

            .img-box {
                width: 300px;
                height: 200px;
                margin: 15px auto;

                img {
                    width: 100%;
                    height: 100%
                }

            }
        }
    }

    .display-box {
        height: 400px;
        // background-color: skyblue;
        background-color: #f0f0f0;

        .display-item-box {
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left-box,
            .right-box {
                width: 50%;
            }

            .left-box {
                .img-show {
                    width: 550px;
                    height: 320px;
                    // background-color: blue;
                    margin: 0 auto;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .right-box {

                .title {

                    font-size: 36px;
                    color: #1565C3;
                    font-weight: bold;
                }

                .info {
                    color: #666;
                    font-size: 18px;
                    margin: 40px 0;
                }

                .btn {
                    color: #fff;
                    cursor: pointer;
                    width: 180px;
                    height: 57px;
                    // background-color: #0187de;
                    line-height: 57px;
                    font-size: 28px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

    }

    .display-box:nth-child(even) {
        background-color: #fff;

        .right-box {
            text-align: right;

            .btn {
                margin-left: auto;
            }
        }
    }

}


#banner2 {
    display: none;
}

#banner1 {
    display: block;
}

@media (max-width: 500px) {
    #banner2 {
        display: block;
    }

    #banner1 {
        display: none;
    }

    .index-box {
        .confirm-box>.confirm {
            // width: 1200px;
            // height: 100%;
            margin: 0 auto;
            width: 100%;
            // background: red;
        }

        .head-tabs {
            background-color: #1565c3;
            color: #fff;
            padding: 0 15px;

            .logo-img {
                display: flex;
                align-items: center;
                padding: 10px 0;

                .img-box {
                    background-color: #01b0bb;
                    width: 45px;
                    height: 45px;
                    border-radius: 5px;
                    margin-right: 20px;

                }

                .text {
                    font-size: 20px;
                }

            }



            .tabs-btn-list {
                display: flex;
                justify-content: space-between;
                padding-bottom: 10px;
            }
        }


        .banner-box {
            height: 207px;

            /deep/.el-carousel {
                height: 100%;

                .el-carousel__container {
                    height: 100%;
                }
            }
        }

        .info-box {
            height: 130px;

            .info-box-img {
                display: block;
                height: 100%;

                img {
                    height: 100%;
                    width: 100%;
                }
            }

            .info-item-box {
                display: none;
            }
        }

        .pc-box {
            display: none;
        }

        .h5-box {
            display: block;

            .display-item-box {
                padding: 20px;
                color: #666;
                background-color: #f0f0f0;

                .title {
                    text-align: center;
                    font-size: 21px;
                    // margin-bottom: 20px;
                    font-weight: bold;
                    color: #1565c3;
                }

                .img-show {
                    width: 100%;
                    height: 210px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .info {
                    text-align: center;
                    padding-top: 10px;
                    font-size: 14px;
                }

                &:nth-child(even) {
                    background-color: #fff;


                }
            }

            .phone-brand {
                .term {
                    text-align: center;
                    font-size: 21px;
                    margin-bottom: 20px;
                    padding: 20px 0;
                    color: #1565c3;
                }

                .brand-box {
                    display: flex;
                    flex-wrap: wrap;



                    .item-box {

                        width: 300px;
                        margin: 0 5px 35px 0;
                        // background-color: #999;
                        width: calc((100% - 10px) / 3); // 这里的10px = (分布个数3-1)*间隙5px, 可以根据实际的分布个数和间隙区调整
                        min-width: calc((100% - 10px) / 3); // 加入min-width、max-width后每个child的宽度就生效了
                        max-width: calc((100% - 10px) / 3);

                        &:nth-child(3n) {
                            margin-right: 0; // 去除第3n个的margin-right
                        }

                        .brand-img {
                            width: 70px;
                            height: 70px;
                            margin: 0 auto;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .brand-text {
                            color: #1565c3;
                            font-size: 14px;
                            text-align: center;
                        }
                    }
                }
            }


        }

    }
}
</style>
